import TechnicalValidationReview from './TechnicalValidationReview.container';

export default TechnicalValidationReview;
